module.exports = __webpack_public_path__ + "static/media/pg_dnm_tide.d1ba1e17.jpg";